interface ChevronRightProps extends React.SVGProps<SVGSVGElement> {
  fill?: string;
  stroke?: string;
  height?: number;
  width?: number;
}

const ChevronRight: React.FC<ChevronRightProps> = ({
  fill = "none",
  stroke = "black",
  height = 13,
  width = 13,
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 13 13"
      fill={fill}
      {...props}
    >
      <path
        d="M4.875 9.75L8.125 6.5L4.875 3.25"
        stroke={stroke}
        strokeWidth="1.08333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ChevronRight;
